const baseUrl = process.env.REACT_APP_API_URL


const fetchSinToken =(endpoint,data,method='GET',type='x-form')=>{
    const url = `${baseUrl}/${endpoint}`;
    
    if (method==='GET'){
        return fetch(url);
    }else{
        switch (type) {
            case 'json':
                return fetch(url,{
                    method,
                    headers:{
                        'Authorization': 'Basic '+btoa(
                            `${process.env.REACT_APP_OAUTH_CLIENT}:${process.env.REACT_APP_OAUTH_PASSWORD}`
                        ) ,
                        // 'Authorization': 'Bearer '+token,
                        'Content-type': 'application/json',
                    },
                    body: JSON.stringify( data )
                })
        
            default:
                return fetch(url,{
                    method,
                    headers:{
                        'Authorization': 'Basic '+btoa(
                            `${process.env.REACT_APP_OAUTH_CLIENT}:${process.env.REACT_APP_OAUTH_PASSWORD}`
                        ) ,
                        // 'Authorization': 'Bearer '+token,
                        'Content-type': 'application/x-www-form-urlencoded'
                    },
                    body: data
                })
        }
    }
}

const fetchConToken =(endpoint,data,method='GET',type='x-form')=>{
    const url = `${baseUrl}/${endpoint}`;
    const token = localStorage.getItem('token') || "";
    if (method==='GET'){
        return fetch(url,{
            method,
            headers:{
                'Authorization': 'Bearer '+token,
            }
        })
    }else {
        switch (type) {
            case 'json':
                return fetch(url,{
                    method,
                    headers:{
                        'Authorization': 'Bearer '+token,
                        'Content-type': 'application/json',
                    },
                    body: JSON.stringify( data )
                })
        
            default:
                return fetch(url,{
                    method,
                    headers:{
                        'Authorization': 'Bearer '+token,
                        'Content-type': 'application/x-www-form-urlencoded'
                    },
                    body: data
                })
        }
    }
}




export {
    fetchSinToken,
    fetchConToken,
}